import { Dialog, Transition } from '@headlessui/react';
import toast from 'react-hot-toast';
import React, { Fragment, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FileUpload, TextButton, Icon } from '../../../components';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../../firebase/clientApp';

// TODO Fix dependency cycle
function UploadPictureModal({
  filePath,
  firestorePath,
  propertyId,
  type,
  navigateOnFinish,
}) {
  const [isOpen, setIsOpen] = useState(type === 'property' ? true : false);

  const handleUploadFinish = async (fileName, url, last) => {
    const functions = getFunctions();
    const createImageData = httpsCallable(functions, 'onCreateImage');

    const updates = { photoName: fileName, photoUrlBE: url };
    if (propertyId) {
      updates.propertyId = propertyId;
    }

    createImageData({
      firestorePath,
      updates,
    })
      .then(() => {
        logEvent(analytics, 'upload_image', {
          content_type: type,
        });
        toast.success('Picture saved!', { position: 'top-right' });
        if (last) {
          if (navigateOnFinish) {
            navigateOnFinish();
          } else {
            setIsOpen(false);
          }
        }
      })
      .catch((err) => {
        logEvent(analytics, 'exception', {
          content_type: type,
          description: `Error saving picture: ${err.code || err}`,
          fatal: false,
        });
        console.error(err);
        toast.error('Error saving picture', { position: 'top-right' });
      });
  };

  const buttonText = (
    <div className="w-full flex justify-start items-center">
      <Icon icon="FiPlusCircle" className="text-3xl" />
    </div>
  );

  return (
    <>
      <div className="relative flex justify-start p-2">
        <TextButton
          classes="hover:text-primary-500 text-primary text-md focus:ring-primary focus:ring-2 focus:ring-offset-0 transition-all"
          style="table"
          srText="Add a New Picture"
          text={buttonText}
          handleClick={() => setIsOpen(true)}
        />
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-30 overflow-y-auto"
          static
          open={isOpen}
          onClose={() => setIsOpen(false)}
        >
          <div className="min-h-screen w-screen sm:px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300 opacity-30"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-neutral-100 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-xl p-6 overflow-hidden text-left align-middle justify-center transition-all transform bg-white shadow-xl rounded-2xl">
                <div className="flex flex-col justify-center items-center">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-neutral-900"
                  >
                    {type === 'logo' ? 'Add Logo' : 'Add Pictures'}
                  </Dialog.Title>
                  <FileUpload
                    label="image"
                    type={type}
                    path={filePath}
                    skipUploadStep={navigateOnFinish}
                    handleFinish={handleUploadFinish}
                  />
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default UploadPictureModal;
